import { Card, Col, Spin } from "antd";
import React, { useEffect, useState } from "react";
import { RouteComponentProps, useHistory } from "react-router-dom";
import "../ApplicationList/index.css";
import CookieManager from "../Cookies";
import { HubConnection, HubConnectionBuilder } from "@microsoft/signalr";
import Notification from "../Notification/Notification.component";
import { Grid } from "@mui/material";
import { API_SSO, SetSSOToken } from "../../api/ssoapi/SSOapi";
import { openUrl } from "../../Utils/LinkUtils.hooks";
import { CLocalStorage } from "../../constants/CLocalStorage";
import { CRoutePaths } from "../../constants/CApp";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../redux-store/store";
import { IApplicationSetup, UpdateApplications } from "../../slices/UserSlice";
import FlashNotifications from "../Notification/FlashNotifications.component";
import { UserControlSlices } from "../../slices/UserControlSlice";
import {
  GetPulishedNotification,
} from "../../api/notifyapi/Notifyapi";
import { NotificationActions } from "../../slices/NotificationSlice";


const ApplicationCard: React.FC<RouteComponentProps> = () => {
  const history = useHistory();
  const dispatch = useDispatch<AppDispatch>();
  const [connection, setConnection] = useState<null | HubConnection>(null);
  const [loading, setLoading] = useState(false);
  const [token, setToken] = useState<string>("");
  const [isFlashContainerOpen, setIsFlashContainerOpen] =
    useState<boolean>(true);
  const user = useSelector((slice: RootState) => slice.user.user);
  const partner = useSelector((slice: RootState) => slice.user.partner);
  const applications = useSelector(
    (slice: RootState) => slice.user.applications
  );
  const [displayApplications, setDisplayApplications] = useState<IApplicationSetup[]>([]);

  const handleFlashContainerClose = () => {
    setIsFlashContainerOpen(false);
  };

  useEffect(() => {
    const apps = applications.filter(app => user?.accessApplications.some(userApp => userApp.applicationID === app.id && userApp.state === "ACTIVE"));
    setDisplayApplications(apps);
  }, [applications, user])

  useEffect(() => {
    console.log("applications", applications)
  }, [applications])

  useEffect(() => {
    if (true || isValidSession()) {
      console.log("GetUser");
      // getUser();
      getAllApplication();

      const ssoToken = sessionStorage.getItem(CLocalStorage.Keys.Token);
      if (ssoToken) {
        setToken(ssoToken);
      }
    } else {
      console.log("handling logout");
      handleLogout();
    }
  }, []);

  useEffect(() => {
    const manager = new CookieManager();
    const cookiesPresent = manager.getCookie(false);
    if (cookiesPresent) {
      const email = sessionStorage.getItem(CLocalStorage.Keys.Email);
      history.push(`/applications?email=${email}`);
    }
    return () => { };
  }, [history]);



  useEffect(() => {
    if (token) {
      const manager = new CookieManager();
      let sessionMangEmail: any = sessionStorage.getItem(
        CLocalStorage.Keys.Email
      );

      sessionMangEmail = encodeURIComponent(sessionMangEmail);
      // ToDo: Need to change this implementation
      console.log("---------------------------------------");
      console.log(sessionMangEmail);
      console.log(manager.getCookie(false));
      console.log(sessionMangEmail);

      const connect = new HubConnectionBuilder()
        .withUrl(
          window.config.signalRUrl +
          `hub/notification?token=${token}&username=${sessionMangEmail}`
        )
        .withAutomaticReconnect()
        .build();

      console.log(connect);
      dispatch(UserControlSlices.GetConnection({ connection: connect }));
      setConnection(connect);
    }
  }, [token]);

  useEffect(() => {
    if (connection) {
      connection
        .start()
        .then(() => {
          connection.on("PostMessage", (message) => {
            console.log(message);
            if (message == "log out") {
              handleLogout();
            }
          });
        })
        .catch((error) => console.log(error));
    }
  }, [connection]);

  useEffect(() => {
    if (connection)
      dispatch(UserControlSlices.GetConnection({ connection: connection }));
  }, [connection]);

  const isValidSession = () => {
    const emailID = sessionStorage.getItem(CLocalStorage.Keys.Email);
    const token = sessionStorage.getItem(CLocalStorage.Keys.Token);

    if (emailID && emailID?.length > 0 && token && token?.length > 0) {
      SetSSOToken(token);
      return true;
    } else {
      return false;
    }
  };

  const getAllApplication = async () => {
    try {
      const apps = await API_SSO.GetApplications();

      // const apiServices = new ApiServices(apiUrl, apiParam);
      // let result = await apiServices.get();
      if (apps.data !== undefined) {
        //setData(apps.data);
        dispatch(UpdateApplications({ applications: apps.data }));
      }
    } catch (error) {
      console.log(error);
    }
  };
  const handleLogout = async () => {
    const email = sessionStorage.getItem(CLocalStorage.Keys.Email);

    dispatch(NotificationActions.UpdateDataAfterLogout());
    dispatch(UserControlSlices.UpdateDataAfterLogout());

    if (email) {
      try {
        setLoading(true);

        const res = await API_SSO.SSOLogout(
          email ? email : "",
          token ? token : ""
        );
        if (res.data) {

          history.replace(CRoutePaths.Login);
          const manager = new CookieManager();
          const deletePresentCookie = manager.deleteCookie("PH_SSO");
        } else {
          console.error("API response indicates failure.");
        }
      } catch (error) {
        console.error("Form validation error: ", error);
      }
    } else {
      history.replace(CRoutePaths.Login);
      let manager = new CookieManager();
      const deletePresentCookie = manager.deleteCookie("PH_SSO");
    }
  };


  const handleOpenApplication = (item: any) => {
    if (item?.setupUrl.loginUrls?.length) {
      const appUrl = item.setupUrl.loginUrls[0] + `?token=${token}`;
      openUrl({
        isNewTab: true,
        isHistoryNeed: false,
        url: appUrl,
      });
    }
  };

  useEffect(() => {
    if (partner.isPartner) {
      console.log(partner);
      dispatch(GetPulishedNotification(partner.partnerType));
    }
  }, [partner.partnerType]);

  useEffect(() => {
    console.log(partner);
  }, [partner]);

  return (
    <>
      {loading ? (
        <div className="loader-container">
          <Spin size="large" />
        </div>
      ) : (
        <>

          {isFlashContainerOpen ? (
            <FlashNotifications onClose={handleFlashContainerClose} />
          ) : (
            <></>
          )}

          <Grid container className="apps-container">
            <Grid item md={6} className="list-container">
              <div className="lists">
                {displayApplications.map((item: any) => {
                  return (
                    <Col key={item.id} className="app_card">
                      <span
                        style={{ textDecoration: "none", cursor: "pointer" }}
                        key={item.id}
                        onClick={() => {
                          handleOpenApplication(item);
                        }}
                      >
                        <Card
                          className="app-list-item-card"
                        >
                          <div className="app_list">
                            <img
                              className={item.name}
                              src={`/SSO/${item.image}`}
                              alt={item.name}
                            />
                          </div>
                          <hr></hr>
                          <div>
                            <div className="span_name">{item.name}</div>
                            {/* <div className="span_description">
                                        {item.description}
                                      </div> */}
                          </div>
                        </Card>
                      </span>
                    </Col>
                  );
                })
                }

              </div>
            </Grid>
            <Grid sx={{ height: "calc(100% - 40px)" }} item md={6}>
              <Notification />
            </Grid>
          </Grid>
        </>
      )}
    </>
  );
};
export default ApplicationCard;
